module.exports = __webpack_public_path__ + "img/shou.972781ff.png";